import React from "react";
import "./profile.css";
import { useTranslation } from "react-i18next";

export default function ConfirmModal({ label, deleteUser, cancelRequest, id, btnLabel, selectedService, setSelectedService, showMediumOption }) {
  const { t } = useTranslation("mediumProfile");
  return (
    <div className="confirm-delete-wrapper register-medium">
      <div data-backdrop="static" className="modal fade" id={id} role="dialog">
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="/images/Union-icon.png" alt="Union-icon" />
              </div>

              <select
                name="selectservice"
                className="select-boxpractive-book"
                value={selectedService}
                onChange={(e) => setSelectedService(e.target.value)}
              >
                <option disabled value="">{t("coachView.selectOne")}</option>
                <option value="1-on-1 Coaching">{t("coachView.services.oneOnOneCoaching")}</option>
                <option value="Group Coaching">{t("coachView.services.groupCoaching")}</option>
                {showMediumOption && (
                  <option value="Mediumship Session">{t("coachView.services.mediumshipSession")}</option>
                )}
              </select>
              <div className="confirm-btn-box">
                <div
                  className="register-medium-confirnation"
                  onClick={cancelRequest}
                  data-dismiss="modal"
                >
                  {t("buttons.cancel")}
                </div>
                <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={() => deleteUser(id)}
                >
                  {btnLabel}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
